/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
  "data": {
    "day": {
      "-1": "i går",
      "-2": "i förrgår",
      "0": "i dag",
      "1": "i morgon",
      "2": "i övermorgon",
      "future": {
        "one": "om {0} dag",
        "other": "om {0} dagar"
      },
      "past": {
        "one": "för {0} dag sedan",
        "other": "för {0} dagar sedan"
      }
    },
    "day-narrow": {
      "-1": "igår",
      "-2": "i förrgår",
      "0": "idag",
      "1": "imorgon",
      "2": "i övermorgon",
      "future": {
        "one": "+{0} d",
        "other": "+{0} d"
      },
      "past": {
        "one": "−{0} d",
        "other": "−{0} d"
      }
    },
    "day-short": {
      "-1": "i går",
      "-2": "i förrgår",
      "0": "i dag",
      "1": "i morgon",
      "2": "i övermorgon",
      "future": {
        "one": "om {0} d",
        "other": "om {0} d"
      },
      "past": {
        "one": "för {0} d sedan",
        "other": "för {0} d sedan"
      }
    },
    "hour": {
      "0": "denna timme",
      "future": {
        "one": "om {0} timme",
        "other": "om {0} timmar"
      },
      "past": {
        "one": "för {0} timme sedan",
        "other": "för {0} timmar sedan"
      }
    },
    "hour-narrow": {
      "0": "denna timme",
      "future": {
        "one": "+{0} h",
        "other": "+{0} h"
      },
      "past": {
        "one": "−{0} h",
        "other": "−{0} h"
      }
    },
    "hour-short": {
      "0": "denna timme",
      "future": {
        "one": "om {0} tim",
        "other": "om {0} tim"
      },
      "past": {
        "one": "för {0} tim sedan",
        "other": "för {0} tim sedan"
      }
    },
    "minute": {
      "0": "denna minut",
      "future": {
        "one": "om {0} minut",
        "other": "om {0} minuter"
      },
      "past": {
        "one": "för {0} minut sedan",
        "other": "för {0} minuter sedan"
      }
    },
    "minute-narrow": {
      "0": "denna minut",
      "future": {
        "one": "+{0} min",
        "other": "+{0} min"
      },
      "past": {
        "one": "−{0} min",
        "other": "−{0} min"
      }
    },
    "minute-short": {
      "0": "denna minut",
      "future": {
        "one": "om {0} min",
        "other": "om {0} min"
      },
      "past": {
        "one": "för {0} min sen",
        "other": "för {0} min sen"
      }
    },
    "month": {
      "-1": "förra månaden",
      "0": "denna månad",
      "1": "nästa månad",
      "future": {
        "one": "om {0} månad",
        "other": "om {0} månader"
      },
      "past": {
        "one": "för {0} månad sedan",
        "other": "för {0} månader sedan"
      }
    },
    "month-narrow": {
      "-1": "förra mån.",
      "0": "denna mån.",
      "1": "nästa mån.",
      "future": {
        "one": "+{0} mån.",
        "other": "+{0} mån."
      },
      "past": {
        "one": "−{0} mån",
        "other": "−{0} mån"
      }
    },
    "month-short": {
      "-1": "förra mån.",
      "0": "denna mån.",
      "1": "nästa mån.",
      "future": {
        "one": "om {0} mån.",
        "other": "om {0} mån."
      },
      "past": {
        "one": "för {0} mån. sen",
        "other": "för {0} mån. sen"
      }
    },
    "nu": [
      "latn"
    ],
    "quarter": {
      "-1": "förra kvartalet",
      "0": "detta kvartal",
      "1": "nästa kvartal",
      "future": {
        "one": "om {0} kvartal",
        "other": "om {0} kvartal"
      },
      "past": {
        "one": "för {0} kvartal sedan",
        "other": "för {0} kvartal sedan"
      }
    },
    "quarter-narrow": {
      "-1": "förra kv.",
      "0": "detta kv.",
      "1": "nästa kv.",
      "future": {
        "one": "+{0} kv.",
        "other": "+{0} kv."
      },
      "past": {
        "one": "−{0} kv",
        "other": "−{0} kv"
      }
    },
    "quarter-short": {
      "-1": "förra kv.",
      "0": "detta kv.",
      "1": "nästa kv.",
      "future": {
        "one": "om {0} kv.",
        "other": "om {0} kv."
      },
      "past": {
        "one": "för {0} kv. sen",
        "other": "för {0} kv. sen"
      }
    },
    "second": {
      "0": "nu",
      "future": {
        "one": "om {0} sekund",
        "other": "om {0} sekunder"
      },
      "past": {
        "one": "för {0} sekund sedan",
        "other": "för {0} sekunder sedan"
      }
    },
    "second-narrow": {
      "0": "nu",
      "future": {
        "one": "+{0} s",
        "other": "+{0} s"
      },
      "past": {
        "one": "−{0} s",
        "other": "−{0} s"
      }
    },
    "second-short": {
      "0": "nu",
      "future": {
        "one": "om {0} sek",
        "other": "om {0} sek"
      },
      "past": {
        "one": "för {0} s sen",
        "other": "för {0} s sen"
      }
    },
    "week": {
      "-1": "förra veckan",
      "0": "denna vecka",
      "1": "nästa vecka",
      "future": {
        "one": "om {0} vecka",
        "other": "om {0} veckor"
      },
      "past": {
        "one": "för {0} vecka sedan",
        "other": "för {0} veckor sedan"
      }
    },
    "week-narrow": {
      "-1": "förra v.",
      "0": "denna v.",
      "1": "nästa v.",
      "future": {
        "one": "+{0} v.",
        "other": "+{0} v."
      },
      "past": {
        "one": "−{0} v",
        "other": "−{0} v"
      }
    },
    "week-short": {
      "-1": "förra v.",
      "0": "denna v.",
      "1": "nästa v.",
      "future": {
        "one": "om {0} v.",
        "other": "om {0} v."
      },
      "past": {
        "one": "för {0} v. sedan",
        "other": "för {0} v. sedan"
      }
    },
    "year": {
      "-1": "i fjol",
      "0": "i år",
      "1": "nästa år",
      "future": {
        "one": "om {0} år",
        "other": "om {0} år"
      },
      "past": {
        "one": "för {0} år sedan",
        "other": "för {0} år sedan"
      }
    },
    "year-narrow": {
      "-1": "i fjol",
      "0": "i år",
      "1": "nästa år",
      "future": {
        "one": "+{0} år",
        "other": "+{0} år"
      },
      "past": {
        "one": "−{0} år",
        "other": "−{0} år"
      }
    },
    "year-short": {
      "-1": "i fjol",
      "0": "i år",
      "1": "nästa år",
      "future": {
        "one": "om {0} år",
        "other": "om {0} år"
      },
      "past": {
        "one": "för {0} år sen",
        "other": "för {0} år sen"
      }
    }
  },
  "locale": "sv"
})
}
